<script setup lang="ts">
import { customPaths } from "~/utils/constants"

definePageMeta({
  page: "promotions-brand"
})

const route = useRoute()
const { locale } = useI18n()

const { data: promotionBrandData, error } = await usePage(
  `/api/gluon/fetchPromotionBrandPage/${locale.value}/${
    route.params.slug as string
  }/promotion_brand.js`
)

const { data: suggestedPromotions } = await useFetch(
  "/api/getAllPromotionsBrand",
  {
    query: { limitQuery: 6, currentPage: route.params.slug as string }
  }
)

const { data: productsEndPromotion } = await useFetch(
  "/api/getProductsEndPromotion"
)

if (error.value) {
  throw createError({
    message: error.value.message,
    statusCode: error.value.statusCode ?? 404
  })
}

const isStillActive = computed(() => {
  if (!promotionBrandData.value?.page) return

  const todayJSON = new Date(
    new Date().getTime() + 120 * 60 * 1000
  ).toISOString()

  return (
    todayJSON >= promotionBrandData.value.page.startDate &&
    todayJSON <= promotionBrandData.value.page.endDate
  )
})

if (!isStillActive.value && !promotionBrandData.value?.page?.showWhenExpired) {
  await navigateTo(customPaths.promotions, {
    redirectCode: 302
  })
}

// Impedisce lo scroll quando cambiano i filtri
useBlockScrollOnFilters()
</script>

<template>
  <div v-if="promotionBrandData">
    <SeoBase v-bind="promotionBrandData.seo" />
    <PagesPromotionBrand
      v-if="isStillActive"
      v-bind="promotionBrandData.page"
      :suggested-promotions="suggestedPromotions"
    />
    <PagesPromoExpired
      v-else-if="productsEndPromotion"
      :products="productsEndPromotion"
      v-bind="promotionBrandData.page"
    />
  </div>
</template>
